import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/home";

export default function HeroSlider() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goTo = useCallback(
    (index: number) => {
      if (isTransitioning) return;
      setIsTransitioning(true);
      setCurrent(index);
      setTimeout(() => setIsTransitioning(false), 600);
    },
    [isTransitioning]
  );

  const next = useCallback(() => {
    goTo((current + 1) % heroSlides.length);
  }, [current, goTo]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
            index === current ? "opacity-100 z-10" : "opacity-0 z-0"
          }`}
        >
          <img
            src={slide.imageUrl}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
            title={slide.title}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60"></div>
        </div>
      ))}

      <div className="absolute inset-0 z-20 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-4">
                热门推荐
              </span>
              <h2
                className="font-heading font-bold text-3xl md:text-5xl text-white mb-3 leading-tight transition-all duration-500"
                key={heroSlides[current].id}
              >
                {heroSlides[current].title}
              </h2>
              <p
                className="text-white/80 text-sm md:text-base mb-6 max-w-lg transition-all duration-500"
                key={`desc-${heroSlides[current].id}`}
              >
                {heroSlides[current].description}
              </p>
              <Link
                to={heroSlides[current].link}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                立即观看
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => goTo(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              index === current
                ? "bg-primary-500 w-7"
                : "bg-white/50 hover:bg-white/80"
            }`}
            aria-label={`切换到第 ${index + 1} 张`}
          ></button>
        ))}
      </div>

      <button
        onClick={() => goTo((current - 1 + heroSlides.length) % heroSlides.length)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/15 backdrop-blur-sm flex items-center justify-center cursor-pointer hover:bg-white/30 transition-colors duration-200"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-white text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/15 backdrop-blur-sm flex items-center justify-center cursor-pointer hover:bg-white/30 transition-colors duration-200"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-white text-xl"></i>
      </button>
    </section>
  );
}